
import { mapState, mapActions, mapGetters } from "vuex";
import AppBar from "../components/common/app-bar.vue";
import InternetStatusBanner from "../components/common/internet-status-banner.vue";
import SubscriptionBanner from "../components/common/subscription-banner.vue";
import FooterMobile from "../components/common/footer-mobile.vue";
import NotificationBanner from "../components/common/notification-banner.vue";
import ChannelIntegrationBanner from "../components/common/channel-integration-banner.vue";
import { WHATSAPP_STEPS } from "../constants/InitialSetupSteps";
// import TypeFormBanner from "../components/common/type-form-banner.vue";
// import PricingRevisionDialog from "../components/dialogs/pricing-revision-dialog.vue";
export default {
  components: {
    InternetStatusBanner,
    AppBar,
    SubscriptionBanner,
    FooterMobile,
    NotificationBanner,
    ChannelIntegrationBanner
    // TypeFormBanner,
    // PricingRevisionDialog
  },
  data() {
    return {
      rawer: false,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      showDialog: true,
      showPricingRevisionDialog: false
    };
  },
  computed: {
    ...mapGetters("auth", ["userInfoLoading"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("restaurant", ["activeChannelCount"]),
    ...mapState("restaurant", [
      "locationDetails",
      "restaurantInfoLoading",
      "notifications"
    ]),
    ...mapGetters("reciever", ["isWhatsappAdded"]),
    isWhatsappSetupIncomplete() {
      if (!this.locationDetails?.restaurants) {
        return false;
      }
      const IntegrationStatus =
        this.locationDetails?.restaurants[0]?.integration_status;
      const matchingStep = WHATSAPP_STEPS.find(
        (step) => step.id === IntegrationStatus
      );

      return !!matchingStep;
    },
    showChannelIntegrationBanner() {
      return (
        this.isWhatsappSetupIncomplete &&
        this.activeChannelCount > 0 &&
        this.isWhatsappAdded
      );
    }
  }
};
